<template>
  <div class="page">
    <b-jumbotron fluid>
      <h1 class="h3">Walne Zebrania Użytkowników</h1>
    </b-jumbotron>

    <div class="container">
      <ul class="h4">
        <li>
          <router-link :to="{ name: 'walne-2026' }">23 kwietnia 2026</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'walne-2019' }">13 grudnia 2019</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'walne',
};
</script>
